import {
  HOME_ACTION,
  SUMMERY_ACTION,
  SELF_SUMMARY_ACTION,
  SUMMERY_UPDATE_ACTION,
  GET_INVITATION_INFO_ACTION,
  LOCATION_ACTION,
  CREATE_REPORT_ACTION,
  GET_REPORT_ACTION,
  DELETE_REPORT_ACTION,
  REMOVE_CONNECTION_ACTION,
  CLEAN_SUMMARY_DATA_ACTION,
  GET_CONFIG_ACTION,
} from "./Constants";

const INITIAL_STATE = {
  summeryUserList: [],
  userInfo: {
    monitored_users: [],
    monitoring_users: [],
    invitees: {
      monitored_users: [],
      monitoring_users: [],
    },
    invites: {
      monitored_users: [],
      monitoring_users: [],
    },
  },
  invitedUserInfo: {
    invite_id: -1,
    invitee: {
      first_name: "",
      last_name: "",
      mobile: "",
      role: -1,
      relation: "",
      user_id: "",
    },
    inviter: {
      user_id: -1,
      first_name: "",
      last_name: "",
      mobile: "",
    },
  },
  locationInfo:{},
  reportData:{},
  reportRecipients: [],
  configData: {}
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case HOME_ACTION:
      return {
        ...state,
        userInfo: {
          monitored_users: action.response.monitored_users
            ? [...action.response.monitored_users]
            : [],
          monitoring_users: action.response.monitoring_users
            ? [...action.response.monitoring_users]
            : [],
          invitees: {
            ...state.userInfo.invitees,
            monitored_users: action.response.invitees.monitored_users
              ? [...action.response.invitees.monitored_users]
              : "",
            monitoring_users: action.response.invitees.monitoring_users
              ? [...action.response.invitees.monitoring_users]
              : "",
          },
          invites: {
            monitored_users: action.response.invites.monitored_users
              ? [...action.response.invites.monitored_users]
              : "",
            monitoring_users: action.response.invites.monitoring_users
              ? [...action.response.invites.monitoring_users]
              : "",
          },
        },
      };
    case SUMMERY_ACTION: {
      return {
        ...state,
        summeryUserList: action.response ? [...action.response] : [],
      };
    };
    case SELF_SUMMARY_ACTION: return {
        ...state,
        selfSummaryData: action.response ? [...action.response] : [],
    };
    case LOCATION_ACTION: {
      return {
        ...state,
        locationInfo: action.response ? { ...action.response } : {},
      };
    };
    case CREATE_REPORT_ACTION:{
      return {
        ...state,
        reportData: action.response ? { ...action.response } : {},
      };
    }
    case GET_REPORT_ACTION: {
      return {
        ...state,
        reportRecipients: [...action.recipients]
      }
    }
    case DELETE_REPORT_ACTION: {
      let list = state.reportRecipients
      let newList = list.filter(each=> each.id!==action.id)
      return {
        ...state,
        reportRecipients: {
          ...newList
        }
      }
    }
    case SUMMERY_UPDATE_ACTION:
      return {
        ...state,
        summeryUserList: [
          ...state.summeryUserList.map((content, i) =>
            content.user_id === action.response[0].user_id
              ? {
                  ...content,
                  info: action.response[0].info,
                  Date: action.response[0].Date,
                }
              : content
          ),
        ],
      };
    case GET_INVITATION_INFO_ACTION:
      return {
        ...state,
        invitedUserInfo: {
          ...state.invitedUserInfo,
          invite_id: action.response.invites.invite_id
            ? action.response.invites.invite_id
            : "",
          invitee: {
            first_name: action.response.invites.invitee.first_name
              ? action.response.invites.invitee.first_name
              : "",
            last_name: action.response.invites.invitee.last_name
              ? action.response.invites.invitee.last_name
              : "",
            mobile: action.response.invites.invitee.mobile
              ? action.response.invites.invitee.mobile
              : "",
            role: action.response.invites.invitee.role
              ? action.response.invites.invitee.role
              : -1,
            relation: action.response.invites.invitee.relation
              ? action.response.invites.invitee.relation
              : "",
            user_id: action.response.invites.invitee.user_id
              ? action.response.invites.invitee.user_id
              : "",
          },
          inviter: {
            user_id: action.response.invites.inviter.user_id
              ? action.response.invites.inviter.user_id
              : "",
            first_name: action.response.invites.inviter.first_name
              ? action.response.invites.inviter.first_name
              : "",
            last_name: action.response.invites.inviter.last_name
              ? action.response.invites.inviter.last_name
              : "",
            mobile: action.response.invites.inviter.mobile
              ? action.response.invites.inviter.mobile
              : "",
          },
        },
      };

    case REMOVE_CONNECTION_ACTION: {
        let monitored = state.userInfo.monitored_users
        .filter(each => (each.subscription.client_user_mapping !== action.deletedId))
        .map(userObj => {
            return userObj
        })

        let monitoring = state.userInfo.monitoring_users
        .filter(each => (each.subscription.client_user_mapping !== action.deletedId))
        .map(userObj => {
            return userObj
        })

        return {
            ...state,
            userInfo: {
                ...state.userInfo,
                monitored_users: monitored,
                monitoring_users: monitoring
            }

        }
    }

    case CLEAN_SUMMARY_DATA_ACTION: {
      return {
        ...state,
        summeryUserList: [],
        selfSummaryData: [],
      }
    }

    case GET_CONFIG_ACTION: {
      return {
        ...state,
        configData: action.response ? { ...action.response } : {}
      }
    }

    default:
      return state;
  }
}
